var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAuthFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.002 10.6875C21.002 4.88012 16.3128 0.1875 10.5039 0.1875C4.69496 0.1875 0.00217603 4.88012 0.00217603 10.6875C-0.0289364 15.4236 3.19983 19.5902 7.87555 20.8478V13.7522H5.25194V10.6875H7.87555V8.50044C7.87555 6.09397 9.62584 4.12633 11.8146 4.12633H14.4382V7.1875H11.8146C11.329 7.1875 10.9376 7.77142 10.9376 8.50044V10.6875H14.4382V13.7522H10.9376V21.1875C16.5291 20.9469 21.0009 16.3498 21.0009 10.6875H21.002Z",
    fill: "#4267B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAuthFacebook);
export default __webpack_public_path__ + "static/media/ic_auth_facebook.a335e5a24eb45c3f1d15c2ff6e16586d.svg";
export { ForwardRef as ReactComponent };